import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    
    code:0
    
}
const mutations={
    getMemberIndex(state,value){
        post(urls.admin.member.index,value).then((result)=>{

            state.result=result



        })

    },
    addMember(state,value){
        post(urls.admin.member.add,value).then((result)=>{

            state.result=result


        })

    },
    editMember(state,value){
        post(urls.admin.member.edit,value).then((result)=>{

            state.result=result


        })

    },
    deleteMember(state,value){
        post(urls.admin.member.delete,value).then((result)=>{

            state.result=result


        })

    },



    
   
 
    

}
const  actions={
    getMemberIndexAction(context,value){
       
        context.commit("getMemberIndex",value)
       
    },
    addMemberAction(context,value){

        context.commit("addMember",value)
       
    },
    editMemberAction(context,value){

        context.commit("editMember",value)

    },
    deleteMemberAction(context,value){

        context.commit("deleteMember",value)

    },
    
  
    
  
    
  
    
   

}

export default {state,mutations,actions}